import React, { useState } from "react";
import DeliveryHead from "../DeliveryHead";
import GoogleMap from "../../../shared/map";
import MainButton from "../../../shared/Button";
import {
  QuotLocationMain,
  HeaderMain,
  ButtonMain,
} from "../styles/QuotLocationStyle";

const QuotLocation = () => {
  const isMobile = window.innerWidth <= 767;
  const [userLocation, setUserLocation] = useState(null);

  const handleGetUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        (error) => {
          console.log("Error getting user location:", error);
        }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  };

  return (
    <QuotLocationMain>
      {!isMobile ? (
        <HeaderMain>
          <DeliveryHead
            Value={50}
            BackLink="/delivery-steps"
            CenterText="Select Location"
            StepText="2 of 4"
            showBox={false}
            showLink={true}
          />
        </HeaderMain>
      ) : null}
      <GoogleMap CurrentUserLocation={userLocation} />
      <ButtonMain>
        <MainButton
          type="button"
          label="Current Location"
          border={true}
          onClick={handleGetUserLocation}
        />
        <MainButton type="button" label="Confirm Location" />
      </ButtonMain>
    </QuotLocationMain>
  );
};

export default QuotLocation;
